import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VideosService {
  path: string = '/api';
  constructor(private apiService: ApiService) { }

  getVideos(airlineId: number) {
    return this.apiService.get<{ data: any[] }>(`${this.path}/v2/airlines/${airlineId}/videos`).pipe(map(videos => videos.data));
  }

  createVideo(embed_code: string, airlineId: number) {
    return this.apiService.post(`${this.path}/v2/airlines/${airlineId}/videos`, { video: { embed_code } });
  }

  updateVideo(id: number, embed_code: string, airlineId: number) {
    return this.apiService.put(`${this.path}/v2/airlines/${airlineId}/videos/${id}`, { video: { embed_code } });
  }

  deleteVideo(id: number, airlineId: number) {
    return this.apiService.delete(`${this.path}/v2/airlines/${airlineId}/videos/${id}`);
  }
}
